import { css } from "@emotion/react";
import PlusJakartaSansRegular from "../assets/fonts/PlusJakartaSans-Regular.ttf";   
import PlusJakartaSansMedium from "../assets/fonts/PlusJakartaSans-Medium.ttf";  
import PlusJakartaSansSemiBold from "../assets/fonts/PlusJakartaSans-SemiBold.ttf"; 
import PlusJakartaSansExtraBold from "../assets/fonts/PlusJakartaSans-ExtraBold.ttf";   

export const reset = css`
    html,
    body {
        min-width: 390px;
    }
    div,
    span,
    applet,
    object,
    iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    blockquote,
    pre,
    a,
    abbr,
    acronym,
    address,
    big,
    cite,
    code,
    del,
    dfn,
    em,
    img,
    ins,
    kbd,
    q,
    s,
    samp,
    small,
    strike,
    strong,
    sub,
    sup,
    tt,
    var,
    b,
    u,
    i,
    center,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    canvas,
    details,
    embed,
    figure,
    figcaption,
    footer,
    header,
    hgroup,
    menu,
    nav,
    output,
    ruby,
    section,
    summary,
    time,
    mark,
    audio,
    video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
        box-sizing: border-box;
    }
    article,
    aside,
    details,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    menu,
    nav,
    section {
        display: block;
    }
    ol,
    ul {
        list-style: none;
    }
    blockquote,
    q {
        quotes: none;
    }
    blockquote:before,
    blockquote:after {
        content: "";
        content: none;
    }
    q:before,
    q:after {
        content: "";
        content: none;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
    a {
        text-decoration: none;
        color: inherit;
    }

    html,
    body {
        height: 100%;
    }
    body {
        width: 100%;
        overflow-x: hidden;
        line-height: 1;
        font-family: "Pretendard", "NotoSansKR", sans-serif;
        margin: 0;
    }

    ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    ::-webkit-scrollbar-track {
        background-color: transparent;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #d8d8d8;
        border-radius: 10px;
        background-clip: padding-box;
        border: 3px solid transparent;
    }

    .fixed {
        overflow: hidden;
    }
    /* .fixed #wrap{position:fixed;width:100%;overflow:hidden} */
    .dim {
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 500;
        display: none;
    }
    .fixed .dim {
        display: block;
    }
    .mq_xl {
    }
    .mq_lg,
    .mq_md,
    .mq_sm,
    .mq_xs {
        display: none !important;
    }

    /* Forms Style */
    input,
    button,
    .select,
    textarea {
        font-size: inherit;
        color: inherit;
    }
    [type="text"],
    [type="password"],
    select {
        height: 40px;
        padding: 0 0.6rem;
    }
    [type="text"],
    [type="password"],
    select,
    textarea,
    button {
        width: 100%;
        border: solid 1px #7b868c;
        background: #fff;
        font-size: 14px;
        color: #3d3e41;
    }

    @media all and (max-width: 1340px) {
        body {
            overflow-x: auto;
        }
        .inner {
            width: 100%;
        }
    }

    @media screen and (max-width: 1024px) {
        .mq_xl {
            display: none !important;
        }
        .mq_lg {
            display: block !important;
        }
    }
    @media screen and (max-width: 960px) {
        .mq_lg {
            display: none !important;
        }
        .mq_md {
            display: block !important;
        }
    }
    @media screen and (max-width: 720px) {
        .mq_md {
            display: none !important;
        }
        .mq_sm {
            display: block !important;
        }
    }
    @media screen and (max-width: 480px) {
        .mq_sm {
            display: none !important;
        }
        .mq_xs {
            display: block !important;
        }
    }

    @font-face {
        font-family: "PlusJakartaSansRegular";
        src: url(${ PlusJakartaSansRegular }) format("truetype");
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: "PlusJakartaSansSemiBold";
        src: url(${ PlusJakartaSansSemiBold }) format("truetype");
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: "PlusJakartaSansMedium";
        src: url(${ PlusJakartaSansMedium }) format("truetype");
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: "PlusJakartaSansExtraBold";
        src: url(${ PlusJakartaSansExtraBold }) format("truetype");
        font-weight: bold;
        font-style: normal;
    }
`;
